<template>
  <div class="modal" :class="{show: show}">
    <myScroll>
      <div class="content">
        <transition name="fade">
          <div class="wrapper" v-if="show" @click="closed" />
        </transition>
        <transition name="zoom-fade">
          <div class="window bounceIn" v-if="show" :style="{width: width + '%'}">
            <ClosedIcon class="icon" @click="closed" />
            <slot />
            <Loader v-if="load" />
          </div>
        </transition>
      </div>
    </myScroll>
  </div>
</template>

<script>
import ClosedIcon from '@/assets/svg/closed-icon.svg?inline'
import Loader from '@/components/Loader'

export default {
  components: {
    ClosedIcon,
    Loader
  },
  props: {
    show: Object,
    load: Boolean,
    width: {
      type: Number,
      default: 35
    }
  },
  methods: {
    closed () {
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal{
  @include box(100%, 100%, fixed, 0, 0, null, null, null, null);
  @include flex(center, center, row);
  z-index: -1;
  .wrapper{
    @include box(100%, 100%, absolute, 0, 0, null, null, null, $modalWrapper);
  }
  .content{
    @include box(100%, auto, absolute, null, null, null, null, null, null);
    @include flex(center, center, row);
    min-height: 100%;
    z-index: 2;
    .window{
      @include box(35%, auto, relative, null, null, null, null, 0.3vw, $modal);
      @include padding(2vw, 2.5vw, 2vw, 2vw);
      @include margin(null, 2vw, null, 2vw);
      @include flex(left, top, column);
      .icon{
        @include box(1.3vw, 1.3vw, absolute, null, 1vw, 1vw, null, null, null);
        transition: 0.3s;
        cursor: pointer;
        &:hover{
          transform: scale(1.3);
          path{
            stroke: $modalCloseHover;
          }
        }
      }
    }
  }
  &.show{
    z-index: 9999;
  }
}
</style>
